module.exports = __webpack_public_path__ + "img/EventosMenu.fc1878a0.png";